import React from "react";
import Select from "react-select"

export class CampoSelect extends React.Component {

    valorDefault = () => {
      if (this.props.selectedValue === undefined) return undefined;
      return this.props.selectedValue;
    };
  
    handleChange = value => {
      this.props.onChange(this.props.name, value);
    };
  
    handleBlur = () => {
      this.props.onBlur(this.props.name, true);
    };
  
  
    loadMulti = () => {
      if (this.props.isMulti === undefined) return false
      return this.props.isMulti
    }
  
    render() {
      return (<Select
        onChange={this.handleChange}
        name={this.props.name}
        isDisabled={this.props.disabled}
        isLoading={false}
        isClearable={this.props.blank}
        isMulti={this.loadMulti()}
        isSearchable={true}
        defaultValue={this.valorDefault()}
        value={this.props.selectedValue}
        placeholder={this.props.placeholder}
        options={this.props.valores}
      />);
    }
  }